import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../components/common-button/CommonButton';

import scss from './UploadFile.module.scss';

const UploadFile = ({ onChange, name, disabled, defaultFileName, customButton, maxWidth, onFocus, onBlur, value }) => {
  const { t } = useTranslation('projects');
  const [fileName, setFileName] = useState('');
  const hiddenFileInput = useRef(null);

  const handleOpenChooseFile = useCallback(() => {
    hiddenFileInput.current.click();
  }, []);

  const onFileChange = useCallback(
    (event) => {
      const fileName = event.target?.files[0]?.name;
      setFileName(fileName);

      new Promise((resolve) => {
        resolve(onChange(event.target?.files[0]));
      });
    },
    [onChange],
  );

  useEffect(() => {
    if (!value) {
      setFileName('');
      hiddenFileInput.current.value = '';
    }
  }, [value]);

  return (
    <div className={scss.uploaderRow} style={{ maxWidth }}>
      <span className={scss.uploadLabel}>{fileName || defaultFileName || t('uploadFile')}</span>

      {customButton ? (
        customButton({ htmlFor: 'file', onClick: handleOpenChooseFile, maxWidth: 120, disabled: disabled })
      ) : (
        <CommonButton htmlFor='file' onClick={handleOpenChooseFile} maxWidth={120} disabled={disabled}>
          {t('upload')}
        </CommonButton>
      )}

      <input
        type='file'
        id={name}
        name={name}
        onChange={onFileChange}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={hiddenFileInput}
        style={{ display: 'none' }}
        disabled={disabled}
      />
    </div>
  );
};

export default UploadFile;
